import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import type { HotelSetUpInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";
import { useHubSpotTracking } from "@/hooks/use-hubspot-tracking";

import { PATHS } from "@/routes/paths";

import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { SETUP_MUTATION } from "./schema";

export const useSetupMutation = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const navigate = useNavigate();
	const { track } = useHubSpotTracking();

	const { mutationFunc } = useCustomMutation(SETUP_MUTATION);

	const onCreateHotel = useCallback(
		(input: HotelSetUpInput) => {
			showLoadingScreenCallback();

			mutationFunc({ variables: { input } })
				.then(({ data, errors }) => {
					if (data?.hotelCreate.hotel?.hotelID && !errors) {
						const hotelID = data.hotelCreate.hotel.hotelID;
						track({
							email: data.hotelCreate.hotel.email ?? "",
							path: "/setup",
						});
						navigate(generatePath(PATHS.HOTEL.SELECT_HOTEL_TEMPLATE, { hotelID }));
					}
				})
				.finally(() => {
					hideLoadingScreenCallback();
				});
		},
		[showLoadingScreenCallback, mutationFunc, track, navigate, hideLoadingScreenCallback],
	);

	return {
		onCreateHotel,
	};
};
